import { CircularProgress, Stack, Typography } from "@mui/material";
import type { DemoRefreshOperation } from "../../../../api/types/demoRefreshTypes";
import { getDemoRefreshStageLabel, isDemoRefreshRunning } from "./demoRefreshHelper";

interface Props {
  operation: DemoRefreshOperation | undefined;
}

const DemoRefreshStatusLine = ({ operation }: Props) => {
  if (operation && isDemoRefreshRunning(operation)) {
    return (
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <CircularProgress size={16} />
        <Typography color="textSecondary">
          Refresh in progress: {getDemoRefreshStageLabel(operation.status)}…
        </Typography>
      </Stack>
    );
  }

  if (operation?.status === "Failed") {
    return (
      <Typography color="error">
        The last refresh failed.{operation.errorMessage && ` ${operation.errorMessage}`}
      </Typography>
    );
  }

  return null;
};

export default DemoRefreshStatusLine;
